export enum NGridColumnFilterType {
    Text = 'text',
    Numeric = 'numeric',
    Boolean = 'boolean',
    Date = 'date',
    DropDown = 'dropdown'
}
